
import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const AlertHistory = styled.div`
  header {
    margin: 20px 20px 0 20px;
    display: flex;
    align-items: center;  
    &__left {
      display: flex;
    }
    &__icon {
      font-size: 18px;
      margin-right: 4.5px;
      color: #C6C5FF;
    }
    &__title {
      color: #1F1F52;
      font-family: Nunito Sans;
      font-size: 20px;
    }
    &__right {
      
    }
    &__button {
      background-color: #F0F0FF;
      border-radius: 15px;
      color: #2E2CBF;
      padding: 5px;
      font-size: 17px;
    }
  }
`;

export default AlertHistory;